import { emitFrontendDiagnostic, frontendDiagnosticsEvents } from '@emporion/ui'
import type {
  AdminExtensionLifecycleEvent,
  AdminExtensionLifecycleEventType,
} from './admin-extension-contract'

const registrySubscribers = new Set<() => void>()
const lifecycleSubscribers = new Set<(event: AdminExtensionLifecycleEvent) => void>()
let registryRevision = 0

export const bumpAdminExtensionRegistryRevision = () => {
  registryRevision += 1
  Array.from(registrySubscribers).forEach((listener) => {
    try {
      listener()
    } catch (error) {
      emitFrontendDiagnostic({
        app: 'admin',
        level: 'warn',
        event: frontendDiagnosticsEvents.adminExtension.registryInvalidationListenerFailed,
        message: 'Admin extension invalidation listener failed',
        error,
      })
    }
  })
}

export const emitAdminExtensionLifecycleEvent = (event: AdminExtensionLifecycleEvent) => {
  Array.from(lifecycleSubscribers).forEach((listener) => {
    try {
      listener(event)
    } catch (error) {
      emitFrontendDiagnostic({
        app: 'admin',
        level: 'warn',
        event: frontendDiagnosticsEvents.adminExtension.lifecycleListenerFailed,
        message: 'Admin extension lifecycle listener failed',
        context: {
          lifecycleEvent: event.type,
          pluginId: event.pluginId,
        },
        error,
      })
    }
  })
}

export const getAdminExtensionRegistryRevision = () => registryRevision

export const subscribeAdminExtensionRegistryInvalidation = (listener: () => void) => {
  registrySubscribers.add(listener)
  return () => {
    registrySubscribers.delete(listener)
  }
}

export const subscribeAdminExtensionLifecycleEvents = (
  listener: (event: AdminExtensionLifecycleEvent) => void,
) => {
  lifecycleSubscribers.add(listener)
  return () => {
    lifecycleSubscribers.delete(listener)
  }
}

export const emitAdminExtensionPluginLifecycle = (
  type: AdminExtensionLifecycleEventType,
  pluginId: string,
) => {
  emitAdminExtensionLifecycleEvent({
    type,
    pluginId,
    timestamp: Date.now(),
  })
  bumpAdminExtensionRegistryRevision()
}
